<template>
  <v-container
    fluid
    class="fill-height pa-0"
  >
    <v-row
      v-if="isLoading"
      justify="center"
      align="center"
      class="fill-height ma-0 black"
    >
      <v-progress-linear
        color="warning"
        top
        absolute
        :value="this.loadingProgress"
      />
      <span class="body-1 loading-text">{{loadingMessage}}</span>
    </v-row>
    <v-row
      v-else
      class="fill-height ma-0"
    >
      <canvas id="canvas" class="fill-height full-width"/>
    </v-row>
  </v-container>
</template>

<script>
  import {OrbitControls} from "three/examples/jsm/controls/OrbitControls"
  import {OBJLoader} from "three/examples/jsm/loaders/OBJLoader"
  import {list3dMesh} from "../../api/api-project"
  import {find} from "lodash/collection"
  import {isEqual} from "lodash/lang"
  import {MapViewEventBus} from "../../helpers/mapview/events"

  const _Processing = Symbol.for("_Processing")

  export default {
    name: "Map3D",
    inject: {_Processing},
    data: () => ({
      isInitialized: false,
      isLoading: true,

      loadingProgress: 0,
      loadingMessage: "",

      mesh: null,
      scene: null,
      camera: null,
      renderer: null
    }),
    methods: {
      setupScene() {
        import("three").then((THREE) => {
          this.scene = new THREE.Scene()
          this.scene.background = new THREE.Color(0x000000)

          //Lights
          this.scene.add(new THREE.HemisphereLight(0xffffbb, 0x080820, 1))
          this.scene.add(new THREE.AmbientLight(0x111111))
        })
      },
      async onMounted() {
        if (this.isInitialized) return

        this.isInitialized = true
        this.setupScene()
        const object = await list3dMesh(this.$apiAuth.getAuthToken(), this.Processing["id_processing"])

        const obj = find(object.data.data["products"], value => isEqual(value["name"], "obj"))
        const jpg = find(object.data.data["products"], value => isEqual(value["name"], "jpg"))

        this.loadingProgress = 0
        this.loadingMessage = "Carregando texturas..."

        import("three").then((THREE) => {
          const texture = new THREE.TextureLoader().load(jpg["url"], () => {
          }, event => this.loadingProgress = event.loaded)
          const material = new THREE.MeshLambertMaterial({
            map: texture,
          })
          this.loadingProgress = 0
          this.loadingMessage = "Carregando modelo 3D..."
          new OBJLoader().load(
            obj["url"],
            group => {
              this.mesh = new THREE.Mesh(group.children[0].geometry, material)
              this.mesh.rotateZ(Math.PI / 2)
              this.mesh.rotateX(Math.PI / 2)
              this.mesh.rotateY(Math.PI / 2)

              this.scene.add(this.mesh)
              this.isLoading = false
              setTimeout(function () {
                this.setupCanvas(THREE)
              }.bind(this), 500)
            },
            event => this.loadingProgress = event.loaded
          )
        })
      },
      setupCanvas(THREE) {
        const canvas = document.getElementById("canvas")
        this.renderer = new THREE.WebGLRenderer({
          canvas: canvas,
          antialias: true,
        })
        const fov = 90,
          aspect = canvas.width / canvas.height,
          near = 1,
          far = 1000
        this.camera = new THREE.PerspectiveCamera(
          fov,
          aspect,
          near,
          far,
        )
        this.camera.position.set(1, 200, 200)

        const controls = new OrbitControls(this.camera, canvas)

        const box3 = new THREE.Box3()
        box3.setFromObject(this.mesh)
        box3.getCenter(controls.target)

        controls.update()

        requestAnimationFrame(this.render)
      },
      render() {
        if (this.resizeRendererToDisplaySize(this.renderer)) {
          const canvas = this.renderer.domElement
          this.camera.aspect = canvas.clientWidth / canvas.clientHeight
          this.camera.updateProjectionMatrix()
        }

        this.renderer.render(this.scene, this.camera)

        requestAnimationFrame(this.render)
      },
      resizeRendererToDisplaySize(renderer) {
        const canvas = renderer.domElement
        const width = canvas.clientWidth
        const height = canvas.clientHeight
        const needResize = canvas.width !== width || canvas.height !== height
        if (needResize) {
          renderer.setSize(width, height, false)
        }
        return needResize
      },
    },
    computed: {
      Processing() {
        return this._Processing()
      }
    },
    created() {
      MapViewEventBus.$on("map-3d-open", this.onMounted)
    }
  }
</script>

<style scoped lang="scss">
  .full-width {
    width: 100%;
  }

  .loading-text {
    color: #FFFFFF !important;
  }
</style>
